import SingleChoice from './SingleChoice';

export default SingleChoice;
